// assets/js/common-nav.js
// document.addEventListener('DOMContentLoaded', () => {
//   const navMain = document.querySelector('.section-nav-main');
//   const navButtonContainer = document.querySelector('.section-nav-button');
//   const buttons = document.querySelectorAll('.section-nav-button .nav-button');

//     const anchorMap = Array.from(buttons)
//         .map((btn) => {
//         const href = btn.getAttribute('href');
//         if (!href || href === '#') return null;
//         const target = document.querySelector(href);
//         return target ? { btn, target } : null;
//         })
//         .filter(Boolean);

//   if (anchorMap.length === 0) return;

//   // 点击处理
//   buttons.forEach((button) => {
//     button.addEventListener('click', (e) => {
//       e.preventDefault();
//       const href = button.getAttribute('href');
//       const target = document.querySelector(href);
//       if (!target) return;

//       buttons.forEach((btn) => btn.classList.remove('active'));
//       button.classList.add('active');

//       target.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });
//     });
//   });

//   let isUserScrollingFromClick = false;

//   const observerOptions = {
//     root: null,
//     rootMargin: '-35% 0px -65% 0px',
//     threshold: 0
//   };

//   const observers = new Map();

//   anchorMap.forEach(({ btn, target }) => {
//     const observer = new IntersectionObserver((entries) => {
//       if (isUserScrollingFromClick) return;
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           buttons.forEach((b) => b.classList.remove('active'));
//           btn.classList.add('active');
//         }
//       });
//     }, observerOptions);

//     observer.observe(target);
//     observers.set(target, observer);
//   });

//   buttons.forEach((button) => {
//     button.addEventListener('click', () => {
//       isUserScrollingFromClick = true;
//       setTimeout(() => {
//         isUserScrollingFromClick = false;
//       }, 1400);
//     });
//   });

//   // 初始 active
//   if (anchorMap.length > 0) {
//     buttons.forEach((btn) => btn.classList.remove('active'));
//     anchorMap[0].btn.classList.add('active');
//   }
// });

// assets/js/common-nav.js
// document.addEventListener('DOMContentLoaded', () => {
//   const navMain = document.querySelector('.section-nav-main');
//   const navButtonContainer = document.querySelector('.section-nav-button .nav-container > div');
//   const buttons = document.querySelectorAll('.section-nav-button .nav-button');
//   const mobileMediaQuery = window.matchMedia('(max-width: 768px)');

//   const getScrollableContainer = (button) => {
//     if (!button) return navButtonContainer;

//     const directContainer = button.closest('.nav-container')?.querySelector(':scope > div');
//     if (directContainer && directContainer.scrollWidth > directContainer.clientWidth) {
//       return directContainer;
//     }

//     let parent = button.parentElement;
//     while (parent) {
//       if (parent.scrollWidth > parent.clientWidth) return parent;
//       parent = parent.parentElement;
//     }
//     return navButtonContainer;
//   };

//   const centerButtonInView = (button) => {
//     if (!button || !mobileMediaQuery.matches) return;
//     const scrollContainer = getScrollableContainer(button);
//     if (!scrollContainer) return;

//     const containerRect = scrollContainer.getBoundingClientRect();
//     const buttonRect = button.getBoundingClientRect();
//     const deltaToCenter =
//       (buttonRect.left - containerRect.left) -
//       (containerRect.width / 2 - buttonRect.width / 2);
//     const targetScrollLeft = scrollContainer.scrollLeft + deltaToCenter;
//     const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
//     const clampedScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

//     scrollContainer.scrollTo({
//       left: clampedScrollLeft,
//       behavior: 'smooth'
//     });
//   };

//   const setActiveButton = (activeButton) => {
//     buttons.forEach((btn) => btn.classList.remove('active'));
//     activeButton.classList.add('active');
//     centerButtonInView(activeButton);
//   };

//   const getTargetByHref = (href) => {
//     if (!href || href === '#' || !href.startsWith('#')) return null;
//     return document.getElementById(href.slice(1));
//   };

//   const anchorMap = Array.from(buttons)
//     .map((btn) => {
//       const href = btn.getAttribute('href');
//       const target = getTargetByHref(href);
//       return target ? { btn, target } : null;
//     })
//     .filter(Boolean);

//   if (anchorMap.length === 0) return;

//   // click handling
//   buttons.forEach((button) => {
//     button.addEventListener('click', (e) => {
//       e.preventDefault();
//       const href = button.getAttribute('href');
//       const target = getTargetByHref(href);
//       if (!target) return;

//       setActiveButton(button);

//       target.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });
//     });
//   });

//   const getScrollTop = () => {
//     return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
//   };

//   const getTargetTop = (target) => {
//     return target.getBoundingClientRect().top + getScrollTop();
//   };

//   const updateActiveButton = () => {
//     const referenceOffset = Math.min(window.innerHeight * 0.35, 320);
//     const currentPosition = getScrollTop() + referenceOffset;
//     let activeIndex = 0;

//     anchorMap.forEach(({ target }, index) => {
//       if (getTargetTop(target) <= currentPosition) {
//         activeIndex = index;
//       }
//     });

//     setActiveButton(anchorMap[activeIndex].btn);
//   };

//   let ticking = false;

//   const requestActiveUpdate = () => {
//     if (ticking) return;
//     ticking = true;

//     window.requestAnimationFrame(() => {
//       updateActiveButton();
//       ticking = false;
//     });
//   };

//   buttons.forEach((button) => {
//     button.addEventListener('click', () => {
//       setTimeout(requestActiveUpdate, 600);
//     });
//   });

//   updateActiveButton();
//   window.addEventListener('scroll', requestActiveUpdate, { passive: true });
//   window.addEventListener('resize', requestActiveUpdate);
// });

// assets/js/common-nav.js
// document.addEventListener('DOMContentLoaded', () => {
//   const navMain = document.querySelector('.section-nav-main');
//   const navButtonContainer = document.querySelector('.section-nav-button');
//   const buttons = document.querySelectorAll('.section-nav-button .nav-button');

//     const anchorMap = Array.from(buttons)
//         .map((btn) => {
//         const href = btn.getAttribute('href');
//         if (!href || href === '#') return null;
//         const target = document.querySelector(href);
//         return target ? { btn, target } : null;
//         })
//         .filter(Boolean);

//   if (anchorMap.length === 0) return;

//   // 点击处理
//   buttons.forEach((button) => {
//     button.addEventListener('click', (e) => {
//       e.preventDefault();
//       const href = button.getAttribute('href');
//       const target = document.querySelector(href);
//       if (!target) return;

//       buttons.forEach((btn) => btn.classList.remove('active'));
//       button.classList.add('active');

//       target.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });
//     });
//   });

//   let isUserScrollingFromClick = false;

//   const observerOptions = {
//     root: null,
//     rootMargin: '-35% 0px -65% 0px',
//     threshold: 0
//   };

//   const observers = new Map();

//   anchorMap.forEach(({ btn, target }) => {
//     const observer = new IntersectionObserver((entries) => {
//       if (isUserScrollingFromClick) return;
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           buttons.forEach((b) => b.classList.remove('active'));
//           btn.classList.add('active');
//         }
//       });
//     }, observerOptions);

//     observer.observe(target);
//     observers.set(target, observer);
//   });

//   buttons.forEach((button) => {
//     button.addEventListener('click', () => {
//       isUserScrollingFromClick = true;
//       setTimeout(() => {
//         isUserScrollingFromClick = false;
//       }, 1400);
//     });
//   });

//   // 初始 active
//   if (anchorMap.length > 0) {
//     buttons.forEach((btn) => btn.classList.remove('active'));
//     anchorMap[0].btn.classList.add('active');
//   }
// });

// assets/js/common-nav.js
(() => {
  const NAV_SELECTOR = '.section-nav-button';
  const ACTIVE_CLASS = 'active';
  const SETTLE_DELAY = 150;
  const CLICK_FALLBACK_DELAY = 2000;
  const TARGET_ALIGNMENT_TOLERANCE = 2;
  const MAX_TARGET_ALIGNMENT_ATTEMPTS = 3;
  const controllerByNav = new WeakMap();
  const controllers = new Set();
  const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
  let updateScheduled = false;
  let retryScheduled = false;
  let retryObserver;
  let retryTimeout;

  const getTargetFromHref = (href) => {
    if (!href || href === '#' || !href.startsWith('#')) return null;

    let targetId;
    try {
      targetId = decodeURIComponent(href.slice(1));
    } catch (error) {
      targetId = href.slice(1);
    }

    const directTarget = document.getElementById(targetId);
    if (directTarget) return directTarget;
    if (!targetId.startsWith('shopify-section-')) return null;

    const sectionKeySeparatorIndex = targetId.lastIndexOf('__');
    if (sectionKeySeparatorIndex === -1) return null;

    const sectionKey = targetId.slice(sectionKeySeparatorIndex + 2);
    if (!sectionKey) return null;

    const expectedSuffix = `__${sectionKey}`;
    let matchedTarget = null;

    for (const sectionElement of document.querySelectorAll('[id^="shopify-section-"]')) {
      if (!sectionElement.id.endsWith(expectedSuffix)) continue;
      if (matchedTarget) return null;
      matchedTarget = sectionElement;
    }

    return matchedTarget;
  };

  const getAnchorButtons = (nav) => Array.from(nav.querySelectorAll('.nav-button'))
    .filter((button) => {
      const href = button.getAttribute('href');
      return href && href !== '#' && href.startsWith('#');
    });

  const normalizeButtonTargets = (nav) => {
    getAnchorButtons(nav).forEach((button) => {
      const href = button.getAttribute('href');
      if (!href.startsWith('#shopify-section-')) return;

      const target = getTargetFromHref(href);
      if (!target) return;

      const currentHref = `#${target.id}`;
      if (href !== currentHref) button.setAttribute('href', currentHref);
    });
  };

  const requestActiveUpdate = () => {
    if (updateScheduled) return;
    updateScheduled = true;
    window.requestAnimationFrame(() => {
      updateScheduled = false;
      controllers.forEach((controller) => {
        if (controller.nav.isConnected) {
          controller.update();
        } else {
          controller.destroy();
          controllers.delete(controller);
        }
      });
    });
  };

  const createController = (nav) => {
    const boundButtons = new WeakSet();
    let isProgrammaticScroll = false;
    let activeTarget;
    let targetAlignmentAttempts = 0;
    let settleTimer;
    let fallbackTimer;

    const getButtons = () => Array.from(nav.querySelectorAll('.nav-button'));

    const getEntries = () => getAnchorButtons(nav)
      .map((button) => ({ button, target: getTargetFromHref(button.getAttribute('href')) }))
      .filter(({ target }) => target && target.isConnected);

    const getScrollableContainer = (button) => {
      const directContainer = button.closest('.nav-container')?.querySelector(':scope > div');
      return directContainer || nav.querySelector('.nav-container > div');
    };

    const centerButtonInView = (button) => {
      if (!mobileMediaQuery.matches) return;
      const scrollContainer = getScrollableContainer(button);
      if (!scrollContainer) return;

      const containerRect = scrollContainer.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();
      const targetScrollLeft = scrollContainer.scrollLeft
        + (buttonRect.left - containerRect.left)
        - (containerRect.width - buttonRect.width) / 2;
      const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

      scrollContainer.scrollTo({
        left: Math.max(0, Math.min(targetScrollLeft, maxScrollLeft)),
        behavior: 'smooth'
      });
    };

    const setActiveButton = (activeButton, center = false) => {
      if (!activeButton) return;
      const changed = !activeButton.classList.contains(ACTIVE_CLASS);
      if (changed) {
        getButtons().forEach((button) => button.classList.remove(ACTIVE_CLASS));
        activeButton.classList.add(ACTIVE_CLASS);
      }
      if (changed || center) centerButtonInView(activeButton);
    };

    const getExpectedTargetTop = (target) => {
      const targetDocumentTop = target.getBoundingClientRect().top + window.scrollY;
      const documentHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      const maxScrollTop = Math.max(0, documentHeight - window.innerHeight);
      return Math.max(0, targetDocumentTop - maxScrollTop);
    };

    const isTargetAligned = (target) => Math.abs(
      target.getBoundingClientRect().top - getExpectedTargetTop(target)
    ) <= TARGET_ALIGNMENT_TOLERANCE;

    const endProgrammaticScroll = () => {
      if (!isProgrammaticScroll) return;
      window.clearTimeout(settleTimer);
      window.clearTimeout(fallbackTimer);

      if (
        activeTarget?.isConnected
        && !isTargetAligned(activeTarget)
        && targetAlignmentAttempts < MAX_TARGET_ALIGNMENT_ATTEMPTS
      ) {
        targetAlignmentAttempts += 1;
        activeTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        fallbackTimer = window.setTimeout(endProgrammaticScroll, CLICK_FALLBACK_DELAY);
        return;
      }

      isProgrammaticScroll = false;
      activeTarget = null;
      targetAlignmentAttempts = 0;
      requestActiveUpdate();
    };

    const controller = {
      nav,
      update() {
        if (isProgrammaticScroll) return;

        controller.bindButtons();
        const entries = getEntries();
        if (!entries.length) return;

        const referencePosition = window.scrollY + Math.min(window.innerHeight * 0.35, 320);
        let activeEntry = entries[0];
        const documentHeight = Math.max(
          document.documentElement.scrollHeight,
          document.body.scrollHeight
        );
        const isAtPageBottom = window.scrollY + window.innerHeight >= documentHeight - 2;

        if (isAtPageBottom) {
          activeEntry = entries[entries.length - 1];
        } else {
          entries.forEach((entry) => {
            const targetTop = entry.target.getBoundingClientRect().top + window.scrollY;
            if (targetTop <= referencePosition) activeEntry = entry;
          });
        }
        setActiveButton(activeEntry.button);
      },
      onScroll() {
        if (!isProgrammaticScroll) return;
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(endProgrammaticScroll, SETTLE_DELAY);
      },
      bindButtons() {
        getAnchorButtons(nav).forEach((button) => {
          if (boundButtons.has(button)) return;
          boundButtons.add(button);
          button.addEventListener('click', (event) => {
            setActiveButton(button, true);
            const target = getTargetFromHref(button.getAttribute('href'));
            if (!target) return;

            event.preventDefault();
            isProgrammaticScroll = true;
            activeTarget = target;
            targetAlignmentAttempts = 0;
            window.clearTimeout(fallbackTimer);
            fallbackTimer = window.setTimeout(endProgrammaticScroll, CLICK_FALLBACK_DELAY);
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
      },
      destroy() {
        window.clearTimeout(settleTimer);
        window.clearTimeout(fallbackTimer);
        activeTarget = null;
      },
      endProgrammaticScroll() {
        endProgrammaticScroll();
      }
    };

    controller.bindButtons();
    return controller;
  };

  const initializeAvailableNavs = () => {
    const navs = Array.from(document.querySelectorAll(NAV_SELECTOR));
    navs.forEach((nav) => {
      normalizeButtonTargets(nav);
      let controller = controllerByNav.get(nav);
      if (!controller) {
        controller = createController(nav);
        controllerByNav.set(nav, controller);
      } else {
        controller.bindButtons();
      }
      controllers.add(controller);
    });

    const hasMissingTargets = navs.some((nav) => getAnchorButtons(nav)
      .some((button) => !getTargetFromHref(button.getAttribute('href'))));

    if (hasMissingTargets && !retryObserver) {
      retryObserver = new MutationObserver(scheduleInitialization);
      retryObserver.observe(document.body, { childList: true, subtree: true });
      retryTimeout = window.setTimeout(() => {
        const missingIds = navs.flatMap((nav) => getAnchorButtons(nav)
          .map((button) => button.getAttribute('href'))
          .filter((href) => !getTargetFromHref(href))
          .map((href) => href.slice(1)));
        if (missingIds.length) console.warn('[common-nav] Navigation targets were not found:', missingIds);
        retryObserver.disconnect();
        retryObserver = null;
        retryTimeout = null;
      }, 10000);
    } else if (!hasMissingTargets && retryObserver) {
      retryObserver.disconnect();
      retryObserver = null;
      window.clearTimeout(retryTimeout);
      retryTimeout = null;
    }

    requestActiveUpdate();
  };

  const scheduleInitialization = () => {
    if (retryScheduled) return;
    retryScheduled = true;
    window.requestAnimationFrame(() => {
      retryScheduled = false;
      initializeAvailableNavs();
    });
  };

  const start = () => {
    if (!document.querySelector(NAV_SELECTOR)) return;

    window.addEventListener('scroll', () => {
      controllers.forEach((controller) => controller.onScroll());
      requestActiveUpdate();
    }, { passive: true });
    window.addEventListener('scrollend', () => {
      controllers.forEach((controller) => controller.endProgrammaticScroll());
    });
    window.addEventListener('resize', requestActiveUpdate);
    window.addEventListener('load', requestActiveUpdate, { once: true });
    document.addEventListener('shopify:section:load', scheduleInitialization);
    initializeAvailableNavs();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
